import TeamItem from "./team-item";
export default TeamItem;